import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { extraSubscriberRoles } from 'src/app/constants/extraSubscriberRoles';
import { subscriberRoles } from 'src/app/constants/subscriberRoles';

@Component({
  selector: 'my-subscriptions',
  standalone: false,
  templateUrl: './my-subscriptions.component.html',
  styleUrl: './my-subscriptions.component.scss'
})
export class MySubscriptionsComponent {
  private _subscriptions: string[];
  subscriptionRoles: string[];

  @Input()
  set subscriptions(value: string[]) {
    this._subscriptions = value;
    this.onSubscriptionsChanged(value);
  }

  get subscriptions(): string[] {
    return this._subscriptions;
  }

  private onSubscriptionsChanged(value: string[]) {
    this.filterSubscriptionRoles(value ?? []);
  }

  constructor(private readonly router: Router) {}

  filterSubscriptionRoles(roles: string[]) {
    var subRoles = roles.filter(r => new Set(subscriberRoles).has(r));

    // Fallback
    if(subRoles.length === 0) {
      subRoles = ["User"];
    }

    const extraRoles = roles.filter(r => new Set(extraSubscriberRoles).has(r));;

    this.subscriptionRoles = [...subRoles, ...extraRoles].slice(0, 3) ?? [] // 3 badge limit;
  }

  navigateToSubscriptionsPage(): void {
    this.router.navigate(['/subscriptions']);
  }
}
